import { AlignmentType, Footer, Header, ImageRun, Paragraph } from "docx";
import { cabral_header } from "../docImages/cabral_realstate";

export const styles_cabral_realstate = {
  companyId: ["12438"],
  companyName: "Cabral Real State",
  font: "Arial",
  titleSize: 22,
  textSize: 22,
  lineSpacing: 300,
  marginRight: 1730,
  marginLeft: 1730,
  beforeParagraph: 200,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 200,
          after: 500,
        },
        alignment: AlignmentType.RIGHT,
        children: [
          new ImageRun({
            data: cabral_header,
            transformation: {
              width: 250,
              height: 40,
            },
          }),
        ],
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        text: " ",
        spacing: {
          before: 800,
        },
      }),
    ],
  }),
};
